export const samdocTheme = {
    cores: {
        primaria: '#DC1E2D',    // Vermelho do botão de login
        secundaria: '#4D4D3D',  // Verde oliva/cinza do "SAM"
        terciaria: '#808080',   // Cinza médio
        texto: '#333333',       // Texto escuro
        textoWhite : '#FFFFFF', // Texto branco
        ofuscado: '#666',         // Cinza apagado
        erro: 'red',              // Vermelho para mensagens de erro
        btn:{
            primaria: '#EC9400',
            houver:{
                primaria: '#DD7E34'
            }
        },
        fundo: {
            input:{
                principal: '#FFFFFF', // Fundo branco
                secundario: '#3D3D3D', // Fundo cinza
                placehold: {
                    secundario: '#999' // Texto para fundo cinza
                }
            },
            container:{
                principal: '#FFFFFF',   // Fundo branco
                secundario: '#E9E9E9',  // Fundo cinza claro do container
                terciario: '#2D2D2D'    // Fundo da navbar
            }
        },
    },
    breakpoints:{
        mobile: '480px',
        tablet: '768px',
        laptop: '1024px'
    },
    sombras: {
        padrao: '0px 2px 4px rgba(0, 0, 0, 0.1)'
    }
};
export type ThemeType = typeof samdocTheme;
